export const homeTranslations = {
  en: {
    heroTitle: 'Plix AI',
    heroSubtitle: 'AI and Automation for Your Company',
    heroButton: 'FREE AI CONSULTATION',
    beliefTitle: 'What we do',
    beliefText: 'We transform your documents, reviews, and texts into valuable insights with customized AI solutions.',
    latestPosts: 'Latest Posts',
    newsTitle: 'Latest Posts',
    viewAllButton: 'View All Posts'
  },
  de: {
    heroTitle: 'Plix AI',
    heroSubtitle: 'KI und Automatisierung für Ihr Unternehmen',
    heroButton: 'KOSTENLOSE KI-BERATUNG',
    beliefTitle: 'Was wir tun',
    beliefText: 'Wir verwandeln Ihre Dokumente, Bewertungen und Texte in wertvolle Erkenntnisse - mit maßgeschneiderten KI-Lösungen.',
    latestPosts: 'Neueste Beiträge',
    newsTitle: 'Neueste Beiträge',
    viewAllButton: 'Alle Beiträge ansehen'
  }
}; 